const pokemonTypeToClassname = {
  normal: "badge badge-pill badge-normal mx-1",
  fighting: "badge badge-pill badge-fighting mx-1",
  flying: "badge badge-pill badge-flying mx-1",
  poison: "badge badge-pill badge-poison mx-1",
  ground: "badge badge-pill badge-ground mx-1",
  rock: "badge badge-pill badge-rock mx-1",
  ghost: "badge badge-pill badge-ghost mx-1",
  steel: "badge badge-pill badge-steel mx-1",
  fire: "badge badge-pill badge-fire mx-1",
  water: "badge badge-pill badge-water mx-1",
  grass: "badge badge-pill badge-grass mx-1",
  electric: "badge badge-pill badge-electric mx-1",
  psychic: "badge badge-pill badge-psychic mx-1",
  dragon: "badge badge-pill badge-dragon mx-1",
  dark: "badge badge-pill badge-dark mx-1",
  unknown: "badge badge-pill badge-unknown mx-1",
  shadow: "badge badge-pill badge-shadow mx-1",
};

export default pokemonTypeToClassname;
